module.exports = __webpack_public_path__ + "media/palenque/2waterfalls-bfd23145.jpg";